<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <form (submit)="search()" #form="ngForm" class="form-validate">
      <div class="row mb-0 mb-xl-4">
        <label class="col-form-label col-12 col-xl-auto">
          <i class="bi bi-box me-2"></i>แหล่งข้อมูล
        </label>
        <div class="col-12 col-xl-auto">
          <app-btn-lk2 [(source)]="source"></app-btn-lk2>
        </div>
      </div>
      <div class="row mb-3">
        <label for="fname" class="col-form-label col-12 col-xl-auto">ชื่อ</label>
        <div class="col-12 col-xl-auto">
          <input type="text" class="form-control" id="fname" [(ngModel)]="firstName" name="fname" required
                 #fnameInput="ngModel">
          @if (fnameInput.invalid && (fnameInput.dirty || fnameInput.touched)) {
            <custom-error *ngIf="fnameInput.hasError('required')" error="*จำเป็น"></custom-error>
          }
        </div>
        <label for="lnane" class="col-form-label col-12 col-xl-auto">นามสกุล</label>
        <div class="col-12 col-xl-auto">
          <input type="text" class="form-control" id="lnane" [(ngModel)]="lastName" name="lnane" required
                 #lnameInput="ngModel">
          @if (lnameInput.invalid && (lnameInput.dirty || lnameInput.touched)) {
            <custom-error *ngIf="lnameInput.hasError('required')" error="*จำเป็น"></custom-error>
          }
        </div>
        <div class="col-12 col-xl-auto">
          <button type="submit" class="btn btn-primary mt-xl-0 mt-3">
            <i class="bi bi-search me-1"></i>ตรวจสอบสิทธิ
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <p>
      <i class="bi bi-info-circle-fill me-2" style="color: rgb(33 37 41 / 50%);"></i>
      การค้นหาด้วยชื่อ-นามสกุล สามารถใช้ได้เฉพาะการตรวจสอบสิทธิเท่านั้น
      หากต้องการลงทะเบียนให้ค้นหาด้วยเลขประจำตัวประชาชน
    </p>
    <div class="table-responsive">
      <table class="table table-striped table-borderless caption-top">
        <caption>ผลการค้นหา</caption>
        <thead>
        <tr>
          <th nowrap scope="col">ลำดับ</th>
          <th nowrap scope="col">เลขประจำตัวประชาชน</th>
          <th nowrap scope="col">ชื่อ-สกุล</th>
          <th nowrap scope="col">เดือนปีเกิด</th>
          <th nowrap scope="col">จังหวัด</th>
          <th nowrap scope="col">สิทธิที่ใช้เบิก</th>
          <th nowrap scope="col">ประเภทสิทธิย่อย</th>
        </tr>
        </thead>
        <tbody>
          @for (item of dataList | slice :(page - 1) * pageSize : page * pageSize; let i = $index; track item) {
            <tr>
              <td scope="row">{{ ((page - 1) * pageSize) + (i + 1) }}</td>
              <td>
                <a (click)="checkRights(item)" class="text-decoration-none fw-semibold"
                   routerLink="">{{ item.personalId }}</a>
              </td>
              <td>{{ item.firstName || '-' }}  {{ item.lastName || '-' }}</td>
              <td>{{ (item.parseBirthDate | birthDateWithoutDate) || '-' }}</td>
              <td>{{ item.provinceName || '-' }}</td>
              <td>{{ item.mainInsclName || '-' }}</td>
              <td>{{ item.subInsclName || '-' }}</td>
            </tr>
          } @empty {
            <tr>
              <td colspan="7">
                <app-not-found></app-not-found>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-12">
        <ngb-pagination class="d-flex justify-content-end"
                        [(page)]="page"
                        [pageSize]="pageSize"
                        (pageChange)="pageChange()"
                        [boundaryLinks]="true"
                        [collectionSize]="dataList.length"/>
      </div>
    </div>
  </div>
</div>
